import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const MlaStreetNumberWUT = props => {
  const fieldType = FIELD_TYPES.MLA_STREET_NUMBER;
  const label = useAddressLabel('streetNumber');
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    label: label
  }));
};
//# sourceMappingURL=mla-street-number-wut.js.map